import React from "react";
import { Link, useParams } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { capitalize, isEmpty } from "lodash";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";

// img
import logo from "../../assets/images/logo/pappermap-logo-wordmark.png";
import { useGetWeighBillyId } from "hooks/useWeighBill";
import Spinners from "Components/Common/Spinner";
import { readableDate } from "utils";
import { AppRoutes } from "../../constants";
import { useSelector } from "react-redux";

const WeighBillDetails = (props: any) => {
  //meta title
  document.title = "Papermap | Weigh Bill Details";

  const { id } = useParams();
  const { data: weighBillData, isLoading } = useGetWeighBillyId(id || "");
  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  //Print the Invoice
  const printInvoice = () => {
    window.print();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Weigh Bill" breadcrumbItem="Details" />
          {isLoading ? (
            <Spinners />
          ) : (
            !isEmpty(weighBillData) && (
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <div className="invoice-title">
                        <h4 className="float-end font-size-16">
                          Weigh Bill # {weighBillData.id}
                        </h4>
                        <div className="auth-logo mb-4">
                          <img src={logo} alt="logo" height="20" />
                        </div>
                      </div>
                      <hr />
                      <Row>
                        <Col sm={6}>
                          <address>
                            <strong>Supplier:</strong>
                            <br />
                            {weighBillData.supplier.name}
                          </address>
                        </Col>
                        <Col sm={6} className="text-sm-end">
                          <address>
                            <strong>Expected Delivery Date:</strong>
                            <br />
                            {readableDate(weighBillData.expected_delivery_date)}
                          </address>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <address>
                            <strong>Created On:</strong>
                            <br />
                            {readableDate(weighBillData.created_at)}
                          </address>
                        </Col>
                        <Col sm={6} className="text-sm-end">
                          <address>
                            <strong>Last update on:</strong>
                            <br />
                            {readableDate(weighBillData.updated_at)}
                          </address>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <address>
                            <strong>Tracking number:</strong>
                            <br />
                            {weighBillData.tracking_number}
                          </address>
                        </Col>
                        <Col sm={6} className="text-sm-end">
                          <address>
                            <strong>Vehicle number:</strong>
                            <br />
                            {weighBillData.vehicle_number}
                          </address>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <address>
                            <strong>Payment Status:</strong>
                            <br />
                            {capitalize(weighBillData.payment_status)}
                          </address>
                        </Col>
                        <Col sm={6} className="text-sm-end">
                          <address>
                            <strong>Driver's name:</strong>
                            <br />
                            {weighBillData.driver_name}
                            <br />
                          </address>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <h3 className="font-size-15 fw-bold">
                          Weigh Bill Items
                        </h3>
                      </div>
                      {weighBillData &&
                      weighBillData.weighbill_items.length > 0 ? (
                        <div className="mt-4 mb-4">
                          <div className="table-responsive">
                            <Table className="table align-middle table-nowrap">
                              <thead className="table-light">
                                <tr>
                                  <th scope="col">Product</th>
                                  <th scope="col">Quantity</th>
                                  <th scope="col">Price</th>
                                  <th scope="col">Discount</th>
                                  <th scope="col" className="text-end">
                                    Sub Total
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {weighBillData.weighbill_items.map(
                                  (item: any, index: number) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <h5 className="font-size-14 text-truncate mb-0">
                                            {item.product.name}
                                          </h5>
                                        </div>
                                      </td>
                                      <td>{item.quantity}</td>
                                      <td>
                                        {defaultCurrency}{" "}
                                        {Number(item.cost_price).toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )}
                                      </td>
                                      <td>{item.discount_amt}</td>
                                      <td className="text-end">
                                        {defaultCurrency}{" "}
                                        {Number(
                                          item.cost_price * item.quantity
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </td>
                                    </tr>
                                  )
                                )}
                                <tr>
                                  <td colSpan={4}>
                                    <h6 className="m-0 text-end">Total:</h6>
                                  </td>
                                  <td className="text-end">
                                    <strong>
                                      {defaultCurrency}{" "}
                                      {Number(
                                        weighBillData.weighbill_items.reduce(
                                          (sum, item) =>
                                            sum +
                                            (item.cost_price || 0) *
                                              (item.quantity || 0),
                                          0
                                        )
                                      ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      ) : (
                        <div className="text-center mt-4 mb-4">
                          No items have been added yet.
                        </div>
                      )}
                      <div className="d-print-none">
                        <div className="float-end">
                          <Link
                            to="#"
                            onClick={printInvoice}
                            className="btn btn-success  me-2"
                          >
                            <i className="fa fa-print" />
                          </Link>
                          <Link
                            to={AppRoutes.WEIGHBILLS}
                            className="btn btn-primary w-m"
                          >
                            Back
                          </Link>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(WeighBillDetails);
